import { addToFavoritesText } from 'owa-locstrings/lib/strings/addtofavoritestext.locstring.json';
import { removeFromFavoritesText } from 'owa-locstrings/lib/strings/removefromfavoritestext.locstring.json';
import loc from 'owa-localize';
import StarCharm from 'owa-star-charm/lib/components/StarCharm';
import { observer } from 'mobx-react-lite';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import * as React from 'react';
import { IButtonStyles } from 'office-ui-fabric-react/lib/Button';

export interface ToggleFavoriteButtonProps {
    isInFavorites: boolean;
    isClickDisabled?: boolean;
    animate?: boolean;
    iconStyles?: string;
    buttonStyles?: IButtonStyles;
    spinnerStyles?: string;
    onClick?: (evt: React.MouseEvent<unknown>) => void;
}

const ToggleFavoriteButton = observer(function ToggleFavoriteButton(
    props: ToggleFavoriteButtonProps
) {
    const {
        isInFavorites,
        isClickDisabled,
        animate,
        iconStyles,
        buttonStyles,
        spinnerStyles,
        onClick,
    } = props;

    // We dont support add/remove favorites in explicit logon scenarios
    const userConfiguration = getUserConfiguration();
    if (
        userConfiguration &&
        userConfiguration.SessionSettings &&
        userConfiguration.SessionSettings.IsExplicitLogon
    ) {
        return null;
    }

    return (
        <StarCharm
            isStarred={isInFavorites}
            onClick={onClick}
            isClickDisabled={isClickDisabled}
            animate={animate}
            iconStyles={iconStyles}
            buttonStyles={buttonStyles}
            spinnerStyles={spinnerStyles}
            ariaLabelText={isInFavorites ? loc(removeFromFavoritesText) : loc(addToFavoritesText)}
            tooltip={{
                starred: loc(removeFromFavoritesText),
                unstarred: loc(addToFavoritesText),
            }}
        />
    );
});
export default ToggleFavoriteButton;
